import * as React from 'react';
import './ineligibleEmployeeHiddenView.scss';

export default class IneligibleEmployeeHiddenView extends React.Component {
    render(): React.ReactNode {
        return (
            <div className="ineligible-employee-hidden-view">
                <img
                    alt=""
                    src={require('contents/ineligible.svg')}
                    className="ineligible-icon"
                />
                <p className="ineligible-employee-text">
                    You have no decisions to make, submit your team to complete your review.
                </p>
            </div>
        );
    }
}